module.exports = __webpack_public_path__ + "static/Kavindra-5f97e395a113043ba22b31f952b808a8.jpg";